
import breakpoints from './utils/breakpoints'
import IframeYoutube from './components/IframeYoutube/IframeYoutube'
import IframeVimeo from './components/IframeVimeo/IframeVimeo'
import ToggleElement from './utils/ToggleElement'
import initMenuMobile from './components/Menu/MenuMobile'
import initMegaMenu from './components/Menu/MegaMenu'
import { HeaderScroll } from './components/HeaderScroll/HeaderScroll';
import UploadHelper from './components/UploadHelper/UploadHelper'
import LangChooser from './components/LangChooser/LangChooser'
import DialogHandler from './components/DialogHandler/DialogHandler'
import Form from './components/Form/Form'
import FileUploadValidator from './components/FileUploadValidator/FileUploadValidator'

customElements.define('iframe-youtube', IframeYoutube)
customElements.define('iframe-vimeo', IframeVimeo)

import EmbeddedPostsConsent from './components/EmbeddedPostsConsent/EmbeddedPostsConsent';
const embeddedPosts = [...document.querySelectorAll('.embeddedpost')];
const embeddedPostsConsent = new EmbeddedPostsConsent(embeddedPosts)

// for cookie banner
window.alertBoxClosedAndValid = false;
//will be called on init and after every changes to the CMP
window.consentChecker = function(){
  embeddedPostsConsent.concentEvaluation()

  //dispatch event "alertBoxClosedAndValid"
  if (window.alertBoxClosedAndValid === false && typeof OneTrust !== 'undefined' && OneTrust.IsAlertBoxClosedAndValid() === true ) {
    //prevent second execution of the dispatch event
    window.alertBoxClosedAndValid = true;
    window.dispatchEvent(new Event("alertBoxClosedAndValid"))
  }

}

const ToggleTriggers = [...document.querySelectorAll('[data-toggle-trigger]')]
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}



if (document.getElementById('header')) {
  initMenuMobile({ menuBreakpoint: breakpoints.large })
  initMegaMenu({ largeWidth: breakpoints.large })
  HeaderScroll()
}

new LangChooser('lang-chooser')

const uploadHelperElements = [...document.querySelectorAll('[data-upload-helper]')];
for (let uploadHelperElement of uploadHelperElements) {
  new UploadHelper(uploadHelperElement)
}

new DialogHandler()

const forms = [...document.querySelectorAll('#main form')]
for (let form of forms) {
  new FileUploadValidator(form)
  new Form(form)
}